import React from "react";
import { LazyImageTemplate } from "themes/common/components";

const LazyImage = (props) => {
    return <LazyImageTemplate {...props} />;
};

export default LazyImage;
